<template>
  <div class="mt-2">
    <div style="margin-bottom: 35px;">
      <div class="intent-item z-border-red" style="padding: 10px 15px 0px;">
        <form>
          <v-layout wrap>
            <v-flex xs12 sm6>
              <div class="form-control pa-1" :class="{ 'has-error': errors.has(`name`) }">
                <label>{{ $t('name') }}</label>
                <input
                  :data-vv-as="$t('name')"
                  v-model="data.sub_booking_name"
                  :name="`name`"
                  class="form-control mr-3"
                  type="text"
                  v-validate="'required'"
                />
                <span class="text-error" v-if="errors.has(`name`)">{{ errors.first(`name`) }}</span>
              </div>
            </v-flex>
            <v-flex xs12 sm6>
              <div
                class="form-control pa-1"
                :class="{ 'has-error': errors.has(`max_available_slot`) }"
              >
                <label>{{ $t('bookings_per_time') }}</label>
                <input
                  :data-vv-as="$t('bookings_per_time')"
                  v-model="data.max_available_slot"
                  :name="`max_available_slot`"
                  v-validate="'required'"
                  class="form-control mr-3"
                  type="number"
                />
                <span class="text-error" v-if="errors.has(`max_available_slot`)">{{
                  errors.first(`max_available_slot`)
                }}</span>
              </div>
            </v-flex>
            <v-flex xs12 sm12 v-if="!isEdit">
              <v-btn color="primary" :outline="toggleType" @click="emitToggleType(false)">{{
                $t('select_by_date')
              }}</v-btn>
              <v-btn color="primary" :outline="!toggleType" @click="emitToggleType(true)">{{
                $t('select_date_range')
              }}</v-btn>
            </v-flex>
            <v-flex xs12 sm12 v-show="!toggleType">
              <div class="form-control pa-1" :class="{ 'has-error': errors.has('selectDate') }">
                <label class="mr-3">{{ $t('working_day') }}</label>
                <v-menu
                  ref="openSelectDate"
                  v-model="openSelectDate"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-combobox
                      outline
                      v-model="data.selectDate"
                      multiple
                      chips
                      small-chips
                      prepend-icon="event"
                      readonly
                      v-on="on"
                      hide-details
                      type="select"
                    ></v-combobox>
                  </template>
                  <v-date-picker
                    :allowed-dates="allowedDates"
                    color="primary"
                    v-model="data.selectDate"
                    multiple
                  ></v-date-picker>
                </v-menu>
                <span class="text-error" v-if="errors.has('selectDate')">{{
                  errors.first('selectDate')
                }}</span>
              </div>
            </v-flex>
            <v-flex xs12 sm6 v-show="toggleType">
              <div class="form-control pa-1" :class="{ 'has-error': errors.has('startAtDate') }">
                <label class="mr-3">{{ $t('start_date_booking') }}</label>
                <v-menu
                  ref="openStartDate"
                  v-model="openStartDate"
                  :close-on-content-click="false"
                  full-width
                  max-width="290px"
                  color="primary"
                >
                  <template v-slot:activator="{ on }">
                    <input
                      type="text"
                      class="form-control browser-default"
                      :placeholder="$t('Date')"
                      readonly
                      v-model="data.startAtDate"
                      v-on="on"
                      v-validate="'required'"
                      clearable
                      small
                      name="startAtDate"
                    />
                  </template>
                  <v-date-picker
                    :allowed-dates="allowedDates"
                    color="primary"
                    v-model="data.startAtDate"
                    @input="openStartDate = false"
                  ></v-date-picker>
                </v-menu>
                <span class="text-error" v-if="errors.has('startAtDate')">{{
                  errors.first('startAtDate')
                }}</span>
              </div>
            </v-flex>
            <v-flex xs12 sm6>
              <div class="pa-1">
                <span class="mr-2 ml-2" style="align-self: center;">{{ $t('time_starts') }}</span>
                <time-picker
                  color="primary"
                  v-model="data.startAtTime"
                  hide-disabled-minutes
                  :placeholder="$t('time')"
                  format="HH:mm"
                  full-width
                ></time-picker>
              </div>
            </v-flex>
            <v-flex xs12 sm6 v-show="toggleType">
              <div class="form-control pa-1" :class="{ 'has-error': errors.has('endAtDate') }">
                <label class="mr-3">{{ $t('end_date_booking') }}</label>

                <v-menu
                  ref="openEndDate"
                  v-model="openEndDate"
                  :close-on-content-click="false"
                  full-width
                  max-width="290px"
                  color="primary"
                >
                  <template v-slot:activator="{ on }">
                    <input
                      type="text"
                      class="form-control browser-default"
                      :placeholder="$t('Date')"
                      readonly
                      v-model="data.endAtDate"
                      v-on="on"
                      v-validate="'required'"
                      clearable
                      small
                      name="endAtDate"
                    />
                  </template>
                  <v-date-picker
                    :allowed-dates="allowedDates"
                    color="primary"
                    v-model="data.endAtDate"
                    @input="openEndDate = false"
                  ></v-date-picker>
                </v-menu>
                <span class="text-error" v-if="errors.has('endAtDate')">{{
                  errors.first('endAtDate')
                }}</span>
              </div>
            </v-flex>
            <v-flex xs12 sm6>
              <div class="pa-1">
                <span class="mr-2 ml-2" style="align-self: center;">{{ $t('time_ends') }}</span>
                <time-picker
                  color="primary"
                  v-model="data.endAtTime"
                  hide-disabled-minutes
                  :placeholder="$t('time')"
                  format="HH:mm"
                  full-width
                ></time-picker>
              </div>
            </v-flex>
            <v-flex xs12 sm12 v-if="toggleType && !isEdit">
              <div class="form-control pa-1 mt-1" :class="{ 'has-error': errors.has(`name`) }">
                <label>{{ $t('available_only_on') }}</label>
                <v-select
                  class="form-control"
                  style="min-height: 42px"
                  v-model="data.date"
                  :items="weekday"
                  chips
                  multiple
                  outline
                  hide-details
                  color="primary"
                  type="select"
                ></v-select>
                <span class="text-error" v-if="errors.has(`name`)">{{ errors.first(`name`) }}</span>
              </div>
            </v-flex>
          </v-layout>

          <div class="text-xs-center">
            <small style="color: red" v-if="errorDateTime">{{
              $t('please_enter_end_date_than_starting_date')
            }}</small>
          </div>

          <div class="text-xs-center mt-3">
            <v-btn outline color="grey" :loading="loading" @click="closeEdit">{{
              $t('cancel')
            }}</v-btn>
            <v-btn depressed color="primary" :loading="loading" @click="submitFrom">{{
              $t('Save')
            }}</v-btn>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import TimePicker from '@/components/elements/TimePicker.vue'
import dayjs from 'dayjs'
export default {
  props: ['value', 'isEditDialog', 'isEdit', 'errorDateTime', 'loading', 'toggleType'],
  data() {
    return {
      data: this.value,
      openEndDate: false,
      openStartDate: false,
      openSelectDate: false,
      weekday: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
    }
  },
  components: { TimePicker },
  mounted() {},
  methods: {
    emitToggleType(type) {
      const vm = this
      vm.$emit('update:errorDateTime', false)
      vm.$emit('update:toggleType', type)
    },
    closeEdit() {
      const vm = this
      vm.$emit('update:isEditDialog', false)
    },
    async submitFrom() {
      const vm = this
      let result = await vm.$validator.validateAll()
      if (result) {
        vm.$emit('saveSubBooking')
      }
    },
    allowedDates(val) {
      return dayjs().diff(val, 'days') < 1
    }
  }
}
</script>

<style lang="scss" scoped></style>


// WEBPACK FOOTER //
// src/components/view/intent/calendar/SubBookingAdvancedForm.vue